/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2020/4/20 21:17
 */
export default function getUsername (userInfo?: UserInfo): string {
  if (!userInfo) return 'U'
  const { firstName, lastName, email, accountName, customerAccount, customerEmail } = userInfo || {}
  return `${firstName || ''} ${lastName || ''}`.trim() ||
    email ||
    accountName ||
    customerAccount ||
    customerEmail ||
    'U'
}
